import Croppr from './vendor/croppr/croppr';
import Glide from '@glidejs/glide'
import SlimSelect from 'slim-select'
import AirDatepicker from 'air-datepicker';

document.addEventListener('DOMContentLoaded', function(){
    let cropperElements = document.getElementsByClassName('cropper');
    if (cropperElements) {
        for (var i = 0; i < cropperElements.length; i++) {
            new Croppr(cropperElements[i], {
                aspectRatio: 1,
                maxSize: [201, 201, 'px'],
                minSize: [200, 200, 'px'],
                startSize: [200, 200, 'px']
            });
        }
    }


    let niceSelectElements = document.getElementsByClassName('slim-select');
    if (niceSelectElements) {
        for (var i = 0; i < niceSelectElements.length; i++) {
            new SlimSelect({
                select: niceSelectElements[i]
            });
        }
    }

    let gliderElements = document.getElementsByClassName('glide');
    if (gliderElements) {
        for (var i = 0; i < gliderElements.length; i++) {
            new Glide(gliderElements[i], {
                    type: 'carousel',
                    startAt: 0,
                    perView: 1,
                }).mount()
        }
    }

    let datetimeElements = document.getElementsByClassName('datetime');
    if (datetimeElements) {
        for (var i = 0; i < datetimeElements.length; i++) {
            new AirDatepicker(datetimeElements[i], {
                //isMobile: true,
                position: 'bottom center',
                autoClose: true,
            })
        }
    }

})

